import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {Icon} from 'front-onceforall-core';

function ClonedInvitationTooltip({invitation}) {
  if (!invitation?.clone) {
    return null;
  }

  return (
    <Icon
      tooltip={I18n.t(
        'invitation.sent.clone',
        {
          cloneRegistrationNumber: invitation.clone.registrationNumber,
          originalRegistrationNumber: invitation.registrationNumber
        }
      )}
      icon="info"
      className="ml-2"
    />
  );
}

ClonedInvitationTooltip.propTypes = {
  invitation: PropTypes.object
};

export default ClonedInvitationTooltip;
